import Tooltip from "antd/es/tooltip";
import React from "react";

const SharedAndAssignedTask = ({
  sharedBy = "",
  isSharedActive = true,
  isAssignedActive = true,
}) => {
  return (
    <div className="cardAssignInfo">
      {isSharedActive && (
        <>
          <Tooltip  title={`Shared by ${sharedBy}`} placement="top" showArrow={false}>
            <p className="sharedInfo">Shared by {sharedBy?.length > 8 ? sharedBy.slice(0,0) + "..." : sharedBy}</p>
          </Tooltip>
        </>
      )}
      {isAssignedActive && (
        <>
          <p style={{ left: isSharedActive && "209px" }} className="assignInfo">
            <Tooltip placement="top" title={"Assigned"}>
              Assigned
            </Tooltip>
          </p>
        </>
      )}
    </div>
  );
};

export default SharedAndAssignedTask;
